import character from '../../images/character.svg';
import { IoIosArrowForward } from 'react-icons/io';
import { useNavigate } from "react-router-dom";

export default function CardCoex({ sttstcInfo }: any) {
  const navigate = useNavigate();
  const totEventHandler = () => {
    navigate('/event')
  };
  const totWorkHandler = () => {
    navigate('/total-work');
  };
  const tbmHandler = () => {
    navigate('/tbm-current-status')
  };
  const nonconformityHandler = () => {
    navigate('/nonconformity');
  };
  const suggestHandler = () => { navigate('/sgst'); };
  const stopHandler = () => { navigate('/stop-request', { state: { isRequest: false } }); };

  return (
    <div className='bg-white text- w-full rounded-[8px] md:rounded-[20px] flex flex-col items-center mt-[0.563rem] md:mt-[1.47rem] relative'>
      <img className='absolute w-[3.7rem] top-[-19%] right-[2%] md:w-[9.25rem]' src={character} alt='character' />
      <p className='text-txtBlack font-semibold text-[1rem] mt-[1.06rem] w-[84.7%] md:text-40 md:mt-[2.65rem]'>오늘의 현황</p>
      {/* <div className='w-[1.68rem] h-[1.68rem] bg-[#FFEEEF] rounded-full absolute top-[24%] left-[5%] z-0' /> */}
      <table className='table-fixed text-txtBlack mt-[0.5rem] mr-[0.75rem] w-[79%] z-10 md:mt-[1.25rem] md:mr-[1.875rem]'>
        <tbody>
          <tr className='hover:cursor-pointer relative'>
            <td onClick={totEventHandler} className='w-[40%] text-[0.75rem] sm:text-[0.875rem] md:text-35 whitespace-pre-line text-center pr-[0.5rem] sm:pr-[1.25rem] md:pr-[3.125rem] -translate-y-4 md:-translate-y-[10px]'>총 행사</td>
            <td onClick={totWorkHandler} className='w-[40%] text-[0.75rem] sm:text-[0.875rem] md:text-35 tracking-tighter border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.5rem] md:pb-[1.25rem]'>일반작업/위험작업</td>
            <td onClick={totWorkHandler} className='border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.938rem] md:pb-[2.345rem]' />
            <td onClick={totWorkHandler} className='w-[30%] text-[0.85rem] sm:text-[0.938rem] md:text-[2.345rem] text-mainTxtPoint font-preBold text-right border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.5rem] md:pb-[1.25rem]'>{sttstcInfo.totWrkInfo?.totWrkCnt - sttstcInfo.totWrkInfo?.dngrWrkCnt}/{sttstcInfo.totWrkInfo?.dngrWrkCnt}<span className='text-txtBlack'>건</span></td>
            <td onClick={totWorkHandler} className='text-[0.813rem] md:text-[2.032rem] border-[0.5px] border-x-0 border-t-0 pb-[0.5rem] md:pb-[1.25rem]'><IoIosArrowForward /></td>
          </tr>
          <tr className='hover:cursor-pointer'>
            <td onClick={totEventHandler} className='text-[0.75rem] sm:text-[0.875rem] md:text-[2.187rem] whitespace-pre-line text-center pr-[0.5rem] sm:pr-[1.25rem] md:pr-[3.125rem]'>
              <span className='text-[0.95rem] sm:text-[1.31rem] md:text-[3.275rem] text-mainTxtPoint font-preBold mr-[0.125rem] md:mr-[0.312rem]'>{sttstcInfo.totEvntCnt}</span>건</td>
            <td onClick={tbmHandler} className='text-[0.75rem] sm:text-[0.875rem] md:text-[2.187rem] pt-[0.5rem] md:pt-[1.25rem]' >TBM</td>
            <td onClick={tbmHandler} className='text-[0.82rem] sm:text-[0.938rem] md:text-[2.345rem] text-mainTxtPoint font-preBold pt-[0.5rem] md:pt-[1.25rem] text-right' colSpan={2}>{sttstcInfo.smrtTbmStatInfo?.wrkrCmpltCnt}/{sttstcInfo.smrtTbmStatInfo?.wrkrTotCnt}({sttstcInfo.smrtTbmStatInfo?.wrkrTbmRate}%)</td>
            <td onClick={tbmHandler} className='text-[0.813rem] md:text-[2.032rem] pt-[0.5rem] md:pt-[1.25rem]'><IoIosArrowForward /></td>
          </tr>
        </tbody>
      </table>
      <div className='w-[90%] h-[4.5rem] sm:h-[5.4rem] md:h-[13.5rem] bg-[#FFEEEF] bg-opacity-[54%] rounded-[8px] md:rounded-[20px] my-[0.625rem] md:my-[1.562rem]  flex flex-col justify-center relative pr-[0.4rem] md:pr-[1rem]'>
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] left-[33%]' />
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] right-[36%]' />
        <table className='text-mainTxtPoint text-[1.56rem] md:text-[3.9rem] font-preBold w-full table-fixed text-center'>
          <tbody>
            <tr className='hover:cursor-pointer '>
              <td onClick={nonconformityHandler}>{sttstcInfo.sftyChkDataCnt}</td>
              <td onClick={suggestHandler}>{sttstcInfo.sgstDataCnt}</td>
              <td onClick={stopHandler}>{sttstcInfo.wrkStopDataCnt}</td>
            </tr>
            <tr className='hover:cursor-pointer text-[0.8rem] sm:text-[0.875rem] md:text-[2.187rem] text-txtBlack'>
              <td onClick={nonconformityHandler}>부적합</td>
              <td onClick={suggestHandler}>건의사항</td>
              <td onClick={stopHandler}>작업중지요청</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
